import React, { useEffect } from 'react'
import { Container, Row, Col } from 'reactstrap'
import { connect, useDispatch } from 'react-redux'
import '../debtPayment.scss'
import DebtPaymentText from './basicText'
import styled from 'styled-components'

const BackGroundDiv = styled.div`
    background-image: url(${props => props.src});
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    height: 50vh;
    width: 100%;
`

const BasicBackGround = (props) => {
    return (
        <BackGroundDiv src={props.src} className={'' + (props.classname? props.classname : '')}></BackGroundDiv>
    );
}

export default BasicBackGround